import React, { useEffect, useState } from "react";
import { NB_DocPlaceStampSign_props } from "./type/docplace_stamp_sign.types";
import NbStampSignView from "./view/docplace_stamp_sign.view";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import ConfirmRegisteredSignatureDocPlace from "../../AssignedForms/resouerce/confirm/confirmRegisteredSignature";
import useAxios from "../hook/hook";
import { de } from "date-fns/locale";

const NbRequestSign: React.FC<NB_DocPlaceStampSign_props & {setShowViewRequest:(id: any) => void }> = (props) => {
  const dispatch = useDispatch();
  const [dataSign, setDataSign] = useState([]);
  const [pageActive, setPageActive] = useState("1");
  const {  fetchEsign,getUserSign  } = useAxios();

  let params = useParams();
  

  useEffect(() => {
    fetchEsign('/automation/api/v1.0/RequiredEsignature/Documents');
  }, []);

  const callSetShowOrder = (e: any) => {
    props.setShowViewRequest(e);
  };


  return (
    <>
    <ConfirmRegisteredSignatureDocPlace show={!getUserSign.isValid} close="/docplaceSign"/>
    {
      
      getUserSign.isValid &&
      <NbStampSignView
        title="Sign the Document"
        listDocuments={props.listDocuments}
        id={params.id}
      />
    }
    </>
    
  );
};

export default NbRequestSign;
